import { render } from "./FontSize.vue?vue&type=template&id=62c74e9e"
import script from "./FontSize.vue?vue&type=script&lang=ts"
export * from "./FontSize.vue?vue&type=script&lang=ts"
script.render = render

export default script